import { render } from "./HeadClientSelect.vue?vue&type=template&id=46d45166"
import script from "./HeadClientSelect.vue?vue&type=script&lang=js"
export * from "./HeadClientSelect.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Custom/HeadClientSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46d45166"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46d45166', __exports__)) {
    console.log('reload')
    api.reload('46d45166', __exports__)
  }
  
  module.hot.accept("./HeadClientSelect.vue?vue&type=template&id=46d45166", () => {
    console.log('re-render')
    api.rerender('46d45166', render)
  })

}


export default __exports__